// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/plugins/Effect

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function Binding(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'Binding',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      d: 'M5 1v3.133A4 4 0 002 8h2a2 2 0 012-2 2 2 0 012 2h2a4 4 0 00-3-3.87V1H5zm1 6a1 1 0 00-1 1v3h2V8a1 1 0 00-1-1z',
      fill: 'currentColor',
    })
  );
}
